




























import { Component, Vue, Watch } from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import {PowerBiReport} from "@/modules/PowerBi";
import OwnerReportRepository from "@/repositories/report/OwnerReportRepository";
import Owner from "@/model/cospirit-api/Owner";
import _ from "lodash";

const components = {
};

@Component({ components })
export default class AdminOwnerReports extends Vue {
    @Getter("getCurrentOwner") public currentOwner!: Owner;
    @Getter("getOwnerReports") public ownerReports!: PowerBiReport[];
    @Getter("getCurrentOwnerUuid") public currentOwnerUuid!: string;
    @Getter("isDsi") public isDsi!: boolean;

    @Action("loadOwnerReports") protected loadOwnerReports!: (ownerUuid: string) => void;

    private updateEnabled(reportUuid: string, enable: boolean): void {
        const params = {
            uuid: reportUuid,
            enabled: enable,
        };
        OwnerReportRepository.save(params).then(() => {
            this.loadOwnerReports(_.get(this.currentOwner, "uuid", ""));
        });
    }

}
